import React from 'react';
import styled from 'styled-components';
import { IconName, Icon } from '@bb/elements-web';

type DetailRowProps = {
  icon: IconName;
};

/** A row component to display details with an icon and content for the managed access details page */
const DetailRow: React.FC<DetailRowProps> = ({ icon, children, ...props }) => (
  <RowContainer {...props}>
    <IconContainer>
      <Icon
        icon={icon}
        size={20}
        color="grey"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
    </IconContainer>
    <BodyContainer id="detail-row-body">{children}</BodyContainer>
  </RowContainer>
);

const RowContainer = styled.div`
  display: flex;
  &:not(:last-child) {
    margin-bottom: 32px;
  }
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

const BodyContainer = styled.div`
  margin-left: 32px;
  font-size: 14px;
`;

export default DetailRow;
